export default {
  routes: [
    {
      name: 'briefings',
      path: '/directory/briefings',
      component: () => import('./views/TheBriefingPages.vue'),

    },

    {
      name: 'briefing',
      path: '/directory/briefings/:uuid',
      component: () => import('./views/TheBriefingPage.vue'),
    },
  ]
}
